import { Component, Inject } from "@angular/core";
import {
  NavController,
  AlertController,
  LoadingController,
} from "ionic-angular";
import { FirebaseApp, AngularFire } from "angularfire2";
import { UiService } from "../../providers/ui";
import { UserService } from "../../providers/user";
import moment from "moment";

@Component({
  selector: "page-login",
  templateUrl: "login.html",
})
export class Login {
  loader: any = null;

  firebaseApp: any = null;

  constructor(
    @Inject(FirebaseApp) firebaseApp: any,
    public navCtrl: NavController,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public uiService: UiService,
    public userService: UserService,
    public af: AngularFire,
  ) {
    this.firebaseApp = firebaseApp;
  }

  presentLoading() {
    this.loader = this.loadingCtrl.create({
      content: "Logging...",
      dismissOnPageChange: true,
    });

    return this.loader.present();
  }

  showAlert(message: string) {
    let alert = this.alertCtrl.create({
      title: "Harmonised",
      subTitle: message,
      buttons: ["OK"],
    });
    alert.present();
  }

  showPromptPassword() {
    let prompt = this.alertCtrl.create({
      title: "Don’t know your password?",

      inputs: [
        {
          name: "email",
          placeholder: "Enter your email address",
        },
      ],
      buttons: [
        {
          text: "Reset password",
          handler: data => {
            console.log("Request a password clicked", data.email);
            //firebase.auth().sendPasswordResetEmail(data.email);
            this.firebaseApp
              .auth()
              .sendPasswordResetEmail(data.email)
              .then(user => {
                setTimeout(() => {
                  this.showAlert(
                    "We just sent you a reset link to your email!",
                  );
                }, 600);
              });
          },
        },
      ],
    });
    prompt.present();
  }

  onForgot() {
    this.showPromptPassword();
  }

  onLogin(email: string, password: string) {
    let loader = this.uiService.createLoader();

    return loader
      .present()
      .then(() => {
        return this.userService.loginUser(email, password);
      })
      .catch((error: any) => {
        return this.af.auth
          .logout()
          .then(() => {
            return loader.dismiss();
          })
          .then(() => {
            return this.navCtrl.setRoot(Login);
          })
          .then(() => {
            return this.uiService.showAlert(
              "Whoops",
              (error && error.message) ||
                "Could not log you in, please try again.",
            );
          });
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts